import PolicyPage from "@/components/site/PolicyPage";

export default function TermsOfStay() {
  return <PolicyPage slug="terms" fallbackTitle="Terms of stay" testId="page-terms-of-stay" />;
}
